module.exports = __webpack_public_path__ + "static/media/help.4c53b8f3.svg";